<!--分级地域-->
<template>
  <div class="areaBox" :class="{hasBg: isSelect}" v-show="show">
    <ul>
      <li v-for="(item,index) in dataList">
        <div :class="{clearfix: isSelect, wid146:!isSelect,fl:!isSelect}">
          <el-checkbox v-if="isSelect" class="checkALL fl" :indeterminate="indeterminate[index-1]"
                       v-model="checkAll[index-1]"
                       @change="checkAllChange($event,index,item)"
                       :disabled="checkedDisabled[index-1] || disabled">
          </el-checkbox>
          <p class="areaLv">{{index==='5'?'全国':`${level[index]}级地域`}} <i></i></p>
        </div>
        <el-checkbox-group v-if="isSelect" class="checkbox-group" v-model="checkedCities[index-1]"
                           @change="citiesChange(index-1)">
          <el-checkbox
            v-for="(city,index1) in item"
            :label="city.value"
            :key="city.name"
            :disabled="checkedDisabled[index-1] || disabled">
            {{city.name}}
          </el-checkbox>
        </el-checkbox-group>
        <p v-if="!isSelect" class="placeBox">
          <span class="place" v-for="city in item">
            <i>{{city.name}}:</i>
            <i class="dataStyle">{{city.carousel}} ({{city.num}})</i>
          </span>
        </p>
      </li>
    </ul>
    <!--<div class="operation clearfix" v-if="isSelect">-->
      <!--<span class="fl">已选择:</span>-->
      <!--<ul class="fl clearfix">-->
        <!--<li v-for="(item3,index) in checked">{{item3}}</li>-->
      <!--</ul>-->
    <!--</div>-->
  </div>
</template>

<script>
  export default {
    data () {
      return {
        curPlace: '',
        checkAll: [false, false, false, false],
        checkedCities: [[], [], [], [], []],
        checkedDisabled: [false, false, false, false],
        indeterminate: [false, false, false, false],
        level: ['', '一', '二', '三', '四'],
//        disabled: true,
        show: true,
        checked: []
      }
    },
    props: {
      dataList: {
        type: Object,
        required: '',
        default: () => {
          return {}
        }
      },
      isSelect: {
        type: Boolean,
        required: false,
        default: false
      },
      checkedCity: {
        type: Object,
        required: false,
        default: () => {
          return {}
        }
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      editInit: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    created () {
      if (this.$route.path.indexOf('orderOpr') > -1) {
        for (let v in this.dataList) {
          let areas = []
          this.dataList[v].forEach((v2, i) => {
            areas.push(v2.value)
          })
          // this.checkedCities.splice(v - 1, 1, areas)
          this.citiesChange(v - 1)
        }
        if (this.checkedCity) {
          for (let k in this.checkedCity) {
            let arr = this.checkedCity[k].map(v => {
              return v.value
            })
            this.checkedCities.splice(k - 1, 1, arr)
            if (this.dataList['1']) {
              this.citiesChange(k - 1)
            }
          }
        }
      }
    },
    methods: {
      checkAllChange (event, index, item) {
        let itemArr = item.map(v => {
          return v.value
        })
        if (event.target.checked) {
          this.checkedCities.splice(index - 1, 1, itemArr)
          this.checked = itemArr
        } else {
          this.checkedCities.splice(index - 1, 1, [])
          this.checked = []
        }
        this.indeterminate.splice(index - 1, 1, false)
        this.setCheckDisabled()
        this.$emit('checkCity', {value: this.checked})
      },
      citiesChange (index) {
        this.checked = []
        let checkedCount = this.checkedCities[index].length
        if (this.dataList[index + 1]) {
          this.checkAll[index] = checkedCount === this.dataList[index + 1].length
          this.indeterminate.splice(index, 1, checkedCount > 0 && checkedCount < this.dataList[index + 1].length)
          this.checkedCities[index].forEach((v, i) => {
            this.checked.push(v)
          })
          this.$emit('checkCity', {value: this.checked})
          this.setCheckDisabled()
        }
      },
      setCheckDisabled () {
        let lineIndex = 0
        let flag = false
        this.checkedCities.forEach((v, i) => {
          if (v.length > 0) {
            flag = true
            lineIndex = i
          }
        })
        if (flag) {
          this.checkedCities.forEach((v, i) => {
            if (i !== lineIndex) {
              this.checkedDisabled.splice(i, 1, true)
            }
          })
        } else {
          this.checkedCities.forEach((v, i) => {
            this.checkedDisabled.fill(false)
          })
        }
      },
      commitConf () {
        this.show = false
      },
      cancelConf () {
        this.checked = []
        this.show = false
      }
    },
    watch: {
      dataList () {
        for (let k in this.checkedCity) {
          this.citiesChange(k - 1)
        }
        if(!this.$route.params.type || (this.$route.params.type === 'edit' && !this.editInit)) {
          this.checkedCities = [[], [], [], [], []]
          this.checkAll = [false, false, false, false, false]
          this.setCheckDisabled()
        }
        if (this.checkedCity&&this.$route.params.type) {
          for (let k in this.checkedCity) {
            let arr = this.checkedCity[k].map(v => {
              return v.value
            })
            this.checkedCities.splice(k - 1, 1, arr)
            if (this.dataList['1']) {
              this.citiesChange(k - 1)
            }
          }
        }
      },
      checkedCity () {
        for (let k in this.checkedCity) {
          let arr = this.checkedCity[k].map(v => {
            return v.value
          })
          this.checkedCities.splice(k - 1, 1, arr)
          if (this.dataList['1']) {
            this.citiesChange(k - 1)
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .areaBox {
    .checkALL {
      height: 32px;
      line-height: 32px;
      margin-right: 7px;
    }
    .wid146 {
      width: 146px;
    }
    .areaLv {
      position: relative;
      width: 102px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      color: #495b6c;
      border-bottom: 2px solid #495b6c;
      i {
        position: absolute;
        right: -13px;
        bottom: -2px;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 11px solid #495b6c;
      }
    }
    ul {
      border: 1px solid transparent;
      margin-top: -2px;
    }
    .placeBox {
      /*margin-bottom: 15px;*/
      .place {
        display: inline-block;
        width: 115px;
        height: 35px;
        /*line-height: 42px !important;*/
        text-align: center;
        font-size: 14px;
        color: #495b6c;
        span {
          margin-right: 10px;
        }
      }
    }
    .checkbox-group {
      margin-top: 10px;
      margin-left: 30px;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #2f6599;
      border-color: #2f6599;
    }
    .el-checkbox__inner:hover {
      border-color: #2f6599;
    }
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #2f6599;
      border-color: #2f6599;
    }
    .operation {
      width: 100%;
      border-top: 1px solid #ccc;
      margin-top: 20px;
      padding: 10px 0;
      color: #2f6599;
      ul {
        li {
          float: left;
          color: #2f6599;
          margin-left: 10px;
        }
      }
    }
    .commit {
      float: right;
      padding: 5px 12px !important;
      font-size: 14px !important;
      margin-right: 10px;
    }

    .cancel {
      float: right;
      color: #676767;
      background: #eae8e8 !important;
      border-color: #eae8e8 !important;
    }
  }

  .hasBg {
    padding: 10px;
    background: #f9f9f9;
    width: 835px;
  }

  label.el-checkbox {
    /*width: 84px;*/
  }
</style>
